'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _Player2 = require('../models/Player');

var _Player3 = _interopRequireDefault(_Player2);

var _hlsEvents = require('../hlsjs/constants/hlsEvents');

var _hlsEvents2 = _interopRequireDefault(_hlsEvents);

var _hlsTags = require('../hlsjs/constants/hlsTags');

var _hlsTags2 = _interopRequireDefault(_hlsTags);

var _logging = require('../constants/logging');

var _debugger = require('../../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

var _logCategoryActionLabel = require('../../loggers/logCategoryActionLabel');

var _logCategoryActionLabel2 = _interopRequireDefault(_logCategoryActionLabel);

var _handleInstreamError = require('../utils/handleInstreamError');

var _handleInstreamError2 = _interopRequireDefault(_handleInstreamError);

var _playerName = require('../constants/playerName');

var _playerName2 = _interopRequireDefault(_playerName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-underscore-dangle */
var INSTREAM_AD_META_END = 'X-TUNEIN-AD-EVENT="END"';
var INSTREAM_AD_META_START = 'X-TUNEIN-AD-EVENT="START"';
var TIME_UNTIL_AUTO_REQUEST = 3000;

var InstreamAdPlayer = function (_Player) {
  (0, _inherits3.default)(InstreamAdPlayer, _Player);

  function InstreamAdPlayer(hlsjsPlayer, timeout, isInstreamLoggingEnabled, tuner) {
    (0, _classCallCheck3.default)(this, InstreamAdPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InstreamAdPlayer.__proto__ || (0, _getPrototypeOf2.default)(InstreamAdPlayer)).call(this, _playerName2.default.InstreamAdPlayer));

    _this._onPlayHandler = function () {
      _this._removeFragmentTagListener();
      _this._requestTrackingData();

      // Since the tracking url is being manually requested here,
      // the timeout is used to ignore the tags to avoid
      // _requestTrackingData being trigged by the tags at the same time
      setTimeout(_this._addFragmentTagListener, TIME_UNTIL_AUTO_REQUEST);
    };

    _this._fragmentTagHandler = function (eventName, resp) {
      var hasDateRangeTag = (0, _find2.default)(resp.frag.tagList, function (tag) {
        return tag[0] === _hlsTags2.default.DATERANGE;
      });

      if (!hasDateRangeTag) {
        return;
      }

      var tagMeta = hasDateRangeTag[1];

      if (!tagMeta) {
        return;
      }

      // AD HAS POTENTIALLY BEEN CUT OFF (FORCE UPDATE)
      if (tagMeta.indexOf(INSTREAM_AD_META_END) >= 0) {
        _this._requestTrackingData(true);
        return;
      }

      // AD DATA IS AVAILABLE
      if (tagMeta.indexOf(INSTREAM_AD_META_START) >= 0) {
        _this._requestTrackingData();
        return;
      }
    };

    _this._removeFragmentTagListener = function () {
      _this.hlsjsPlayer.off(_hlsEvents2.default.FRAG_LOADED, _this._fragmentTagHandler);
    };

    _this._addFragmentTagListener = function () {
      _this.hlsjsPlayer.on(_hlsEvents2.default.FRAG_LOADED, _this._fragmentTagHandler);
    };

    _this._parseCookieString = function (str, name) {
      var splitReadyStr = '; ' + str;
      var parts = splitReadyStr.split('; ' + name + '=');
      return parts.length === 2 ? parts.pop().split(';').shift() : undefined;
    };

    _this.hlsjsPlayer = hlsjsPlayer;
    _this.timeout = timeout;
    _this.isInstreamLoggingEnabled = isInstreamLoggingEnabled;
    _this.trackingUrl = null;
    _this.tuner = tuner;
    return _this;
  }

  (0, _createClass3.default)(InstreamAdPlayer, [{
    key: 'on',
    value: function on(event, callback) {
      this.hlsjsPlayer.on(event, callback);
      this.addListener(event, callback);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      this.hlsjsPlayer.off(event, callback);
      this.removeListener(event, callback);
    }
  }, {
    key: 'load',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url, format, position, trackingUrl) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.trackingUrl = trackingUrl;
                _context.next = 4;
                return this.hlsjsPlayer.load(url, format);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                (0, _handleInstreamError2.default)(_context.t0, _logging.actions.masterUrlTimeout, _logging.actions.masterUrlError, this.isInstreamLoggingEnabled);

                throw _context.t0;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function load(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'play',
    value: function play() {
      return this.hlsjsPlayer.play().then(this._onPlayHandler).catch(_noop2.default);
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.stop();
    }
  }, {
    key: 'unload',
    value: function unload() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.unload();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.destroy();
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this.hlsjsPlayer.getPlaybackRate();
    }
  }, {
    key: 'canChangePlaybackRate',
    value: function canChangePlaybackRate() {
      return this.hlsjsPlayer.canChangePlaybackRate();
    }
  }, {
    key: 'changePlaybackRate',
    value: function changePlaybackRate(rate) {
      this.hlsjsPlayer.changePlaybackRate(rate);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      this.hlsjsPlayer.setVolume(volume);
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this.hlsjsPlayer.getVolume();
    }
  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      this.hlsjsPlayer.setTitle(title);
    }
  }, {
    key: 'getTimes',
    value: function getTimes() {
      return this.hlsjsPlayer.getTimes();
    }
  }, {
    key: 'requestInstreamAds',
    value: function requestInstreamAds() {
      this._requestTrackingData();
    }
  }, {
    key: '_requestTrackingData',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var response, ads, hasAds, playerTime, adMetadata;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios2.default.get(this.trackingUrl, {
                  timeout: this.timeout
                });

              case 3:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = {};

              case 6:
                response = _context2.t0;
                ads = (0, _get2.default)(response, 'data.avails[0].ads', []);
                hasAds = ads.length > 0;

                if (!hasAds && this.isInstreamLoggingEnabled) {
                  (0, _logCategoryActionLabel2.default)({ action: _logging.actions.trackingURLEmpty });
                }

                playerTime = this.getTimes() || {};
                adMetadata = (0, _extends3.default)({
                  playerPosition: playerTime.elapsedSeconds,
                  forceUpdate: forceUpdate
                }, response.data);


                this.tuner.trigger(this.tuner.events.instreamAd, adMetadata);
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t1 = _context2['catch'](0);

                (0, _handleInstreamError2.default)(_context2.t1, _logging.actions.trackingURLTimeout, _logging.actions.trackingURLError, this.isInstreamLoggingEnabled);

                _debugger2.default.log('an error occurred while polling for ads', _context2.t1);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 15]]);
      }));

      function _requestTrackingData() {
        return _ref2.apply(this, arguments);
      }

      return _requestTrackingData;
    }()
  }]);
  return InstreamAdPlayer;
}(_Player3.default);

exports.default = InstreamAdPlayer;
//# sourceMappingURL=InstreamAdPlayer.js.map